module.exports = __webpack_public_path__ + "static/img/OregonShelf-RA.e44c231.png";